module.exports = __webpack_public_path__ + "static/media/400048_01.b9ea9924.png";